<div style="display: flex; flex-direction: column; gap: 0.75rem;">

  <!-- Logical operator row (only shown when more than one condition) -->
  @if (conditions.length > 1) {
    <div class="flex items-center gap-2">
      <span class="text-sm text-gray-500" i18n>Match</span>
      <div class="dropdown">
        <select [formControl]="logicalOperatorControl">
          <option *ngFor="let op of logicalOperators" [ngValue]="op">{{ op }}</option>
        </select>
      </div>
      <span class="text-sm text-gray-500" i18n>of the following conditions</span>
    </div>
  }

  <!-- Condition rows -->
  <div style="display: flex; flex-direction: column; gap: 0.5rem;">
    <div *ngFor="let condGroup of conditions; let i = index"
         class="flex gap-2 items-center"
         [formGroup]="condGroup">

      <!-- Field selector -->
      <div class="dropdown flex-1">
        <select formControlName="field">
          <option *ngFor="let seg of segments" [value]="seg.field">{{ seg.label }}</option>
        </select>
      </div>

      <!-- Operator selector (shown only after field is selected) -->
      @if (condGroup.get('field')?.value) {
        <div class="dropdown flex-1">
          <select formControlName="operator">
            <option *ngFor="let op of getOperatorsForGroup(condGroup)" [value]="op.value">
              {{ op.label }}
            </option>
          </select>
        </div>

        <!-- Value selector -->
        <div class="flex-1">
          <ng-container *ngIf="isMultiSelectOperator(condGroup); else singleSelect">
            <ng-multiselect-dropdown
              formControlName="value"
              [placeholder]="multiselectPlaceholder"
              [settings]="multiselectSettings"
              [data]="getOptionsForGroup(condGroup)">
            </ng-multiselect-dropdown>
          </ng-container>
          <ng-template #singleSelect>
            <div class="dropdown">
              <select formControlName="value">
                <option [ngValue]="null"></option>
                <option *ngFor="let opt of getOptionsForGroup(condGroup)" [ngValue]="opt.value">
                  {{ opt.label }}
                </option>
              </select>
            </div>
          </ng-template>
        </div>
      }

      <!-- Remove button -->
      <button type="button"
              class="btn-icon text-gray-400 hover:text-red-500 flex-shrink-0"
              (click)="removeCondition(i)"
              *ngIf="conditions.length > 1">
        <i class="fas fa-times"></i>
      </button>

    </div>
  </div>

  <!-- Add condition -->
  <button type="button"
          class="flex-none uppercase font-bold text-base text-grayDark tracking-wide no-underline hover:no-underline focus:no-underline px-6 py-3 border-b-4 pb-4 border-transparent hover:text-primary fadeInFadeOut"
          (click)="addCondition()">
    <i class="fas fa-plus mr-1"></i>
    <ng-container i18n>Add condition</ng-container>
  </button>

</div>
